exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#mculist[data-v-3f3c0b9e] {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n", ""]);

